import { AnimationGroup } from './AnimationGroup';
import { getEasing, getJsEasing } from './utils';
import { getWebAnimation } from './api/webAnimations';
import { getCSSAnimation } from './api/cssAnimations';
import { prepareAnimation } from './api/prepare';
import { getElement, getNamedEffect } from './api/common';
function getElementCSSAnimation(target, animationOptions) {
  const namedEffect = getNamedEffect(animationOptions);
  if (!namedEffect) {
    return null;
  }
  if (!namedEffect.style) {
    // if this named effect does not have a style method, attempt to get group of Web Animations
    if (animationOptions.effectId && target) {
      return getElementAnimation(target, animationOptions.effectId);
    }
    return null;
  }
  const effectNames = namedEffect.getNames(animationOptions);
  const element = typeof target === 'string' ? getElement(target) : target;
  const animations = element == null ? void 0 : element.getAnimations();
  const animationNames = (animations == null ? void 0 : animations.map(anim => anim.animationName)) || [];
  const filteredAnimations = [];
  effectNames.forEach(name => {
    if (animationNames.includes(name)) {
      filteredAnimations.push(animations == null ? void 0 : animations.find(anim => anim.animationName === name));
    }
  });
  return filteredAnimations != null && filteredAnimations.length ? new AnimationGroup(filteredAnimations) : null;
}
function getElementAnimation(target, effectId) {
  const element = typeof target === 'string' ? getElement(target) : target;
  // somehow get the right animations
  const animations = element == null ? void 0 : element.getAnimations().filter(anim => {
    const id = anim.id || anim.animationName;
    // if no id/name just return all animations
    return id ? id.startsWith(effectId) : true;
  });
  return animations != null && animations.length ? new AnimationGroup(animations) : null;
}
function getScrubScene(target, animationOptions, trigger, sceneOptions) {
  if (sceneOptions === void 0) {
    sceneOptions = {};
  }
  const {
    disabled,
    allowActiveEvent,
    ...rest
  } = sceneOptions;
  const animation = getWebAnimation(target, animationOptions, trigger, rest);
  let typeSpecificOptions = {};
  if (trigger.trigger === 'view-progress' && !window.ViewTimeline) {
    // TODO(ameerf): consider doing this only for bgscrub to not affect the other scroll effects
    const viewSource = trigger.element || getElement(trigger.componentId);
    const {
      ready
    } = animation;
    return animation.animations.map(partialAnimation => {
      return {
        /* we use getters for start and end in order to access the animation's start and end
          only when initializing the scrub scene rather than immediately */
        get start() {
          return partialAnimation.start;
        },
        get end() {
          return partialAnimation.end;
        },
        viewSource,
        ready,
        getProgress() {
          return animation.getProgress();
        },
        effect(__, p) {
          const {
            activeDuration
          } = partialAnimation.effect.getComputedTiming();
          const {
            delay
          } = partialAnimation.effect.getTiming();
          partialAnimation.currentTime = ((delay || 0) + (activeDuration || 0)) * p;
        },
        disabled,
        destroy() {
          partialAnimation.cancel();
        }
      };
    });
  } else if (trigger.trigger === 'pointer-move') {
    const {
      centeredToTarget,
      transitionDuration,
      transitionEasing
    } = animationOptions;
    typeSpecificOptions = {
      target: animation.target,
      centeredToTarget,
      allowActiveEvent
    };
    if (animationOptions.customEffect && transitionDuration) {
      typeSpecificOptions.transitionDuration = transitionDuration;
      typeSpecificOptions.transitionEasing = getJsEasing(transitionEasing);
    }
  }
  return {
    ...typeSpecificOptions,
    getProgress() {
      return animation.getProgress();
    },
    effect(__, p, v, active) {
      animation.progress(v ? {
        // @ts-expect-error spread error on p
        ...p,
        v,
        active
      } : p);
    },
    disabled,
    destroy() {
      animation.cancel();
    }
  };
}
export { getCSSAnimation, getWebAnimation, getElementCSSAnimation, getElementAnimation, getScrubScene, prepareAnimation, getEasing };
//# sourceMappingURL=motion.js.map